module.exports = __webpack_public_path__ + "img/checkup_en_v3.a6f880a8.png";